// Enum số
// ncdinh 29/12/2022

export default {
  maxPrintHeight: '328', // Chiều cao tối đa của dropdown in (10 chứng từ)
};
